import { render, staticRenderFns } from "./base2.vue?vue&type=template&id=d5a55b84&scoped=true"
import script from "./base2.vue?vue&type=script&lang=js"
export * from "./base2.vue?vue&type=script&lang=js"
import style0 from "./base2.vue?vue&type=style&index=0&id=d5a55b84&prod&lang=scss&scoped=true"
import style1 from "./base2.vue?vue&type=style&index=1&id=d5a55b84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a55b84",
  null
  
)

export default component.exports